import { render, staticRenderFns } from "./CancelHeading.vue?vue&type=template&id=9af28312&scoped=true&"
import script from "./CancelHeading.vue?vue&type=script&lang=js&"
export * from "./CancelHeading.vue?vue&type=script&lang=js&"
import style0 from "./CancelHeading.vue?vue&type=style&index=0&id=9af28312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af28312",
  null
  
)

export default component.exports